import React from 'react'

import {format} from 'd3-format'

import {Chart} from 'react-stockcharts'
import {BarSeries} from 'react-stockcharts/lib/series'
import {MouseCoordinateY} from 'react-stockcharts/lib/coordinates'
import {YAxis} from 'react-stockcharts/lib/axes'
import {plotDataLengthBarWidth} from 'react-stockcharts/lib/utils'
import {Brush} from 'react-stockcharts/lib/interactive'

export const Volume = ({brushEnabled, handleBrush}) => {
  return(
    <Chart
      id='volume'
      yExtents={d => d.volume}
      height={83}
      origin={[0,225]}
    >
      <BarSeries
        width={plotDataLengthBarWidth}
        widthRatio={0.3}
        yAccessor={d => d.volume}
        fill={d => d.close > d.open ? '#889988' : '#FF8888'}
      />
      <YAxis
        axisAt='left'
        orient='left'
        ticks={5}
        tickFormat={format('.2s')}
        fontFamily='GothamHTF'
        tickStroke='#d3d3d3'
        tickPadding={10}
        fontSize={12}
      />
      <MouseCoordinateY
        at='left'
        orient='left'
        displayFormat={format('.4s')}
        fontFamily='GothamHTF'
        rectWidth={50}
        arrowWidth={5}
      />
      {brushEnabled &&
        <Brush
          enabled={brushEnabled}
          type='2D'
          onBrush={handleBrush}
        />
      }
    </Chart>
  )
}
